import Image from 'next/image';
import { Star } from 'lucide-react';

const platforms = [
  { name: 'Yelp', logo: '/logos/Yelp.webp' },
  { name: 'HomeAdvisor', logo: '/logos/HomeAdvisor.webp' },
  { name: 'Houzz', logo: '/logos/Houzz.webp' },
  { name: 'Google', logo: '/logos/Google.webp' },
  { name: "Angie's List", logo: '/logos/Angilist.webp' },
];

export default function SocialProof() {
  return (
    <section className="bg-darkBackground pb-[150px] pt-[120px] px-4 text-white relative z-10">
      <div className="container mx-auto text-center">
        <h2 className="text-lg lg:text-lg text-white font-light mb-4 uppercase tracking-[6px]">
          Trusted by Homeowners Across Los Angeles
        </h2>
        <p className="lg:text-2xl text-white max-w-xl mx-auto mb-12 font-light font-gilda">
          Consistent quality. Consistent 5-star ratings.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-6">
          {platforms.map(({ name, logo }, i) => (
            <div
              key={i}
              className="border border-white/30 py-20 px-4 flex flex-col items-center justify-center bg-white/5 rounded-md backdrop-blur-sm"
            >
              <div className="flex mb-4">
                {[...Array(5)].map((_, idx) => (
                  <Star key={idx} className="w-5 h-5 mr-1 fill-white text-transparent" />
                ))}
              </div>
              <Image
                src={logo}
                alt={`${name} logo`}
                title={`${name} logo`}
                width={100}
                height={40}
                className="h-[40px] object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
